// Phone & WhatsApp constants used across CTAs (sticky button, hero,
// contact, mobile bottom bar). The displayed E.164 number must match
// the wa.me link target.
export const FIRM_PHONE_E164 = "+96569656963";
export const FIRM_PHONE_DISPLAY = "+965 6965 6963";
export const FIRM_WHATSAPP_E164 = "96569656963"; // wa.me uses no plus
export const FIRM_EMAIL = "contact@aldakheel.legal";
export const FIRM_ADDRESS_AR = "مدينة الكويت — مبنى الفتوح، الدور الثالث";
export const FIRM_ADDRESS_EN = "Kuwait City — Al-Futooh Building, 3rd Floor";

// Default WhatsApp greeting prefilled into the chat window when a
// visitor taps a sticky button. Kept short so it doesn't overflow.
export const WA_DEFAULT_GREETING_AR =
  "مرحباً، أرغب في الاستفسار عن خدمات مجموعة الدخيل القانونية.";
export const WA_DEFAULT_GREETING_EN =
  "Hello, I'd like to enquire about Aldakheel Legal Group services.";

// Page-specific pre-filled WhatsApp messages. Keyed by page identifier
// or service slug so a `useWhatsApp(key)` lookup gives the right
// greeting on whichever page the user clicks the button from.
export const WA_MESSAGES = {
  home: {
    ar: "مرحباً، أرغب في الاستفسار عن خدمات مجموعة الدخيل القانونية.",
    en: "Hello, I'd like to enquire about Aldakheel Legal Group services.",
  },
  about: {
    ar: "مرحباً، أرغب في معرفة المزيد عن مجموعة الدخيل القانونية.",
    en: "Hello, I'd like to learn more about Aldakheel Legal Group.",
  },
  consultation: {
    ar: "مرحباً، أرغب في حجز استشارة قانونية بقيمة 50 د.ك.",
    en: "Hello, I'd like to book a legal consultation (KWD 50).",
  },
  ai: {
    ar: "مرحباً، استخدمت الذكاء القانوني وأرغب في تحويل التحليل إلى استشارة مع محامٍ.",
    en: "Hello, I used the AI legal assistant and want to convert the analysis into a consultation with a lawyer.",
  },
  contact: {
    ar: "مرحباً، أرغب في التواصل مع مجموعة الدخيل القانونية.",
    en: "Hello, I'd like to get in touch with Aldakheel Legal Group.",
  },
  services: {
    ar: "مرحباً، أرغب في الاستفسار عن الخدمات القانونية لديكم.",
    en: "Hello, I'd like to enquire about your legal services.",
  },
  // Per-service-slug overrides (10 services). Keys MUST match
  // src/data/services.js SERVICES[].slug.
  "family-law": {
    ar: "مرحباً، أرغب في استشارة قانونية بخصوص الأحوال الشخصية.",
    en: "Hello, I need legal advice on a personal status (family law) matter.",
  },
  "labor-law": {
    ar: "مرحباً، أرغب في استشارة قانونية بخصوص قضية عمالية.",
    en: "Hello, I need legal advice on a labor / employment matter.",
  },
  "corporate-law": {
    ar: "مرحباً، أرغب في استشارة قانونية للشركات أو العقود.",
    en: "Hello, I need legal advice for a corporate / commercial matter.",
  },
  "civil-litigation": {
    ar: "مرحباً، أرغب في استشارة قانونية بخصوص نزاع مدني.",
    en: "Hello, I need legal advice on a civil litigation matter.",
  },
  "criminal-defense": {
    ar: "مرحباً، أرغب في استشارة قانونية بخصوص قضية جزائية.",
    en: "Hello, I need legal advice on a criminal defense matter.",
  },
  contracts: {
    ar: "مرحباً، أرغب في استشارة بخصوص صياغة أو مراجعة عقد.",
    en: "Hello, I'd like a consultation on drafting or reviewing a contract.",
  },
  arbitration: {
    ar: "مرحباً، أرغب في استشارة بخصوص التحكيم أو فض النزاعات.",
    en: "Hello, I'd like a consultation on arbitration or dispute resolution.",
  },
  "business-consultation": {
    ar: "مرحباً، أرغب في الاستفسار عن خدمة المستشار القانوني الدائم للشركات.",
    en: "Hello, I'd like to enquire about the retained business counsel service.",
  },
  "real-estate": {
    ar: "مرحباً، أرغب في استشارة قانونية بخصوص العقارات أو المقاولات.",
    en: "Hello, I need legal advice on a real estate / construction matter.",
  },
  "intellectual-property": {
    ar: "مرحباً، أرغب في استشارة قانونية بخصوص الملكية الفكرية.",
    en: "Hello, I need legal advice on intellectual property.",
  },
};

export const buildWhatsAppLink = (
  message = WA_DEFAULT_GREETING_AR
) =>
  `https://wa.me/${FIRM_WHATSAPP_E164}?text=${encodeURIComponent(message)}`;

/**
 * Resolve the right pre-filled message for a given page key + language
 * and return a ready-to-use wa.me URL.
 *   getPageWaLink("family-law", "ar")
 */
export const getPageWaLink = (pageKey, lang = "ar") => {
  const entry = WA_MESSAGES[pageKey] || WA_MESSAGES.home;
  const text = entry[lang] || entry.ar || WA_DEFAULT_GREETING_AR;
  return buildWhatsAppLink(text);
};

// Consultation pricing (UI-only for Phase 1 — real KNET/MyFatoorah
// keys will be wired later).
export const CONSULTATION_FEE_KWD = 50;
